import { createContext, useContext } from 'react'

export const ThreadPreviewReadOnlyContext = createContext(false)

export function useThreadPreviewReadOnly() {
  return useContext(ThreadPreviewReadOnlyContext)
}
